import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.75721 5L12.4391 5C12.591 5.00217 12.7389 5.04967 12.8644 5.13661C12.99 5.22355 13.0878 5.3461 13.1456 5.48908C13.2035 5.63205 13.2188 5.78916 13.1897 5.94093C13.1607 6.09269 13.0885 6.23244 12.9822 6.34285L8.6529 10.7663C8.58077 10.8404 8.49496 10.8991 8.40042 10.9393C8.30587 10.9794 8.20446 11 8.10204 11C7.99962 11 7.89821 10.9794 7.80366 10.9393C7.70911 10.8991 7.6233 10.8404 7.55118 10.7663L3.22187 6.34285C3.11554 6.23244 3.04338 6.09269 3.01433 5.94093C2.98528 5.78916 3.00062 5.63205 3.05845 5.48908C3.11627 5.3461 3.21404 5.22355 3.33963 5.13661C3.46522 5.04967 3.61311 5.00217 3.76497 5H3.75721Z",
		fill: "currentColor"
	})
});
export default SvgSortDown;
